/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const permissions = currentUser?.permissions ?? [];

  return {
    // 检查是否有某个权限
    hasPerm: (perm: string) => {
      return permissions.includes(perm);
    },
    // 检查是否包含任意一个权限
    hasAnyPerm: (perms: string[]) => {
      return perms.some((perm) => permissions.includes(perm));
    },
  };
}

